import React, { useContext, useEffect, useState } from 'react';
import ListGroup from "react-bootstrap/ListGroup";
import {Badge, Button, Col, Row} from "react-bootstrap";
import { Context } from "../../index";
import {fetchCurrentUserAssigns} from "../../http/bookAPI";
import { observer } from "mobx-react-lite";
import {LIBRARY_ROUTE, STORE_ROUTE} from "../../utils/consts";
import {useNavigate} from "react-router-dom";
import {
    FaListAlt,
    FaBookOpen,
    FaExclamationTriangle,
    FaHourglassHalf,
    FaBell,
    FaEnvelopeOpenText, FaRegEnvelope
} from "react-icons/fa";
import {FaBox, FaCircleXmark, FaTrashCan} from "react-icons/fa6"; // ✅ Импорт иконок

const ColReader = observer(({onAssignSelect, setActiveComponent, onClose}) => {
    const { book } = useContext(Context);
    const { user } = useContext(Context)
    const navigate = useNavigate()
    const [hoveredItemId, setHoveredItemId] = useState(null);
    const demoAssignments = [
        {
            id: 'demo-1',
            assignment_status: 'READING',
            isDemo: true,
            book: { title: 'Demo Assign: The Reader Awakens' }
        },
        {
            id: 'demo-2',
            assignment_status: 'READING_RE',
            isDemo: true,
            book: { title: 'Demo Assign: Secrets of Reviewing' }
        },
        {
            id: 'demo-3',
            assignment_status: 'REPORTED',
            isDemo: true,
            book: { title: 'Demo Assign: Reporting Guide' }
        },
        {
            id: 'demo-4',
            assignment_status: 'REPORTED_RV',
            isDemo: true,
            book: { title: 'Demo Assign: Validation Checklist' }
        },
        {
            id: 'demo-5',
            assignment_status: 'SUCCESS',
            isDemo: true,
            book: { title: 'Demo Assign: From Read to Reward' }
        }
    ];



    document.querySelector('.shake-badge')
    document.querySelectorAll('.shake-badge').forEach(el => {
        el.style.animation = 'shake 0.5s ease-in-out infinite';
    });

    const handleClick = (b) => {
        book.setSelectedCurrentUserAssign(b);
        onAssignSelect(b);  // Передаем выбранный ассигмент в родительский компонент
        if (onClose) {
            onClose();
        }
    };

    const viewAllAssigns = () => {
        user?.setActiveComponent("AssignUserList")
        if (onClose) {
            onClose();
        }
    };

    const assignmentsToDisplay = book.currentuserassigns.length > 0
        ? book.currentuserassigns
        : demoAssignments;



    //   <span style={{ marginLeft: "-10px" }} className="badge text-bg-primary rounded-pill bg-success bg-gradient me-1">5</span>
    return (
        <div>
            <h5 style={{ marginBottom: '-16px' }} className="mx-auto p-2 text-muted">Assignments</h5>
            <div style={{ marginBottom: '5px', fontSize: 'small' }} className="mx-auto text-muted p-2">
                {book.currentuserassigns.length > 0
                    ? 'Your recent assignments:'
                    : 'Demo assignments shown below until you take your first real assignment. They will disappear once you start.'}
            </div>
            <Col style={{ maxHeight: 400, overflowY: "auto" }}>
            <ListGroup
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}
            >
                {assignmentsToDisplay.map(b => {
                    const isDemo = b.isDemo;
                    const hasStaffMsg = !!b?.review_link_staff_comment?.trim();
                    return (
                        <ListGroup.Item
                            key={b.id}
                            className={`list-group-item list-group-item-action small truncated-text shadow-sm ${
                                hoveredItemId === b.id || book.selectedCurrentUserAssign?.id === b.id ? 'list-group-item-success' : ''
                            }`}
                            style={{
                                cursor: isDemo ? 'not-allowed' : 'pointer',
                                opacity: isDemo ? 0.85 : 1,
                                borderRadius: '.25rem',
                                transition: 'transform .2s',
                                boxShadow: hoveredItemId === b.id || book.selectedCurrentUserAssign?.id === b.id
                                    ? '0px 4px 12px rgba(0, 0, 0, 0.1)'
                                    : 'none',
                                paddingTop: '0.20rem',
                                paddingBottom: '0.20rem',
                            }}
                            onMouseEnter={() => !isDemo && setHoveredItemId(b.id)}
                            onMouseLeave={() => !isDemo && setHoveredItemId(null)}
                            onClick={() => {
                                if (!isDemo) handleClick(b);

                            }}
                        >
                            <Col className="d-flex align-items-start">
                <span style={{
                    marginLeft: "15px",
                    marginRight: "0px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    maxWidth: "105%"
                }}>
                    {b.book.title}
                </span>
                            </Col>

                            {b.assignment_status === 'READING' && (
                                <Badge bg="success" pill className="position-absolute text-dark ms-3 top-50 start-0 bg-opacity-50 translate-middle">R</Badge>
                            )}
                            {b.assignment_status === 'READING_RIDT' && (
                                <Badge bg="warning" pill className="position-absolute text-dark ms-3 top-50 start-0 translate-middle">R</Badge>
                            )}
                            {b.assignment_status === 'READING_RE' && (
                                <Badge bg="danger" pill className="position-absolute text-white ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center"   style={{ width: '22px', height: '20px' }}>
                                    <FaBell className="animate__animated animate__bounceIn animate__infinite" />
                                </Badge>
                            )}
                            {hasStaffMsg ? (
                                <Badge bg="danger" pill className="position-absolute text-white ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center bg-opacity-100"   style={{ width: '20.5px', height: '20px' }}>
                                    <FaRegEnvelope className="animate__animated animate__heartBeat animate__infinite" size={10} />
                                </Badge>
                            ) : (
                                <>
                                    {b.assignment_status === 'REPORTED' && (
                                        <Badge bg="success" pill className="position-absolute text-dark ms-3 top-50 start-0 bg-opacity-50 translate-middle">A</Badge>
                                    )}
                                    {b.assignment_status === 'REPORTED_RFU' && (
                                        <Badge bg="warning" pill className="position-absolute text-dark ms-3 top-50 start-0 translate-middle">A</Badge>
                                    )}
                                    {b.assignment_status === 'REPORTED_RV' && (
                                        <Badge bg="danger" pill className="position-absolute text-white ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center" style={{ width: '22px', height: '20px' }}>
                                            <FaTrashCan className="animate__animated animate__wobble animate__infinite" />
                                        </Badge>
                                    )}
                                    {b.assignment_status === 'REPORTED_EXP' && (
                                        <Badge
                                            bg="warning"
                                            pill
                                            className="position-absolute text-dark ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center"
                                            style={{ width: '22px', height: '20px' }}
                                            title="Grace period — please confirm the assignment"
                                        >
                                            <FaHourglassHalf className="animate__animated animate__pulse animate__infinite" />
                                        </Badge>
                                    )}

                                </>
                            )}
                            {b.assignment_status === 'SUCCESS' && (b.check_status === 'COMPLETE' || b.check_status === 'AWAITING') && (
                                <Badge
                                    bg="success"
                                    pill
                                    className="position-absolute ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center"
                                    style={{ width: '20px', height: '20px' }}
                                >
                                    <i className="bi bi-check fs-5"></i>
                                </Badge>
                            )}
                            {b.assignment_status === 'SUCCESS' && b.check_status === 'COMPLAINT' && (
                                <Badge
                                    bg="danger"
                                    pill
                                    className="position-absolute ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center shadow-sm"
                                    style={{ width: 21, height: 20 }}
                                    title="Complaint received — pending review"
                                    aria-label="Complaint received"
                                >
                                    <FaTrashCan
                                        className="animate__animated animate__wobble animate__infinite text-white"
                                        style={{ animationDuration: '1.4s' }}
                                        size={12}
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                </Badge>
                            )}

                            {b.assignment_status === 'SUCCESS' && b.check_status === 'REFUNDED' && (
                                <Badge
                                    bg="danger"
                                    pill
                                    className="position-absolute ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center shadow-sm"
                                    style={{ width: 20, height: 20 }}
                                    title="Refunded"
                                    aria-label="Refunded"
                                >
                                    <FaCircleXmark
                                        className="animate__animated animate__rotateIn animate__repeat-3 animate__infinite text-white"
                                        style={{ animationDuration: '1.6s' }}
                                        size={12}
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                </Badge>
                            )}


                            {b.assignment_status === 'SUCCESS' && b.check_status === 'DECLINED' && (
                                <Badge
                                    bg="success"
                                    pill
                                    className="position-absolute bg-capasity-50 ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center shadow-sm"
                                    style={{ width: '20px', height: '20px' }}
                                    title="Complaint declined"
                                    aria-label="Complaint declined"
                                >
                                    <i className="bi bi-check fs-5 animate__animated animate__wobble animate__repeat-3 animate__infinite text-white"></i>
                                </Badge>
                            )}


                        </ListGroup.Item>
                    );
                })}





            </ListGroup>

            </Col>
            <div className="mt-2 d-flex justify-content-center" style={{ gap: "6px" }}>
                <Button
                    variant="outline-success"
                    className="shadow-sm btn-sm d-flex align-items-center"
                    onClick={viewAllAssigns}
                >
                    <FaListAlt className="me-2" /> All
                </Button>

                <Button
                    onClick={() => {
                        book.setSelectedLanguage('');
                        book.setSelectedGenre('');
                        book.setSelectedPrice('');
                        book.setSelectedAssType('');
                        navigate(LIBRARY_ROUTE);
                    }}
                    variant="outline-success"
                    className="shadow-sm btn-sm d-flex align-items-center"
                >
                    <FaBookOpen className="me-2" /> Library
                </Button>

                <Button
                    onClick={() => {
                        book.setSelectedLanguage('');
                        book.setSelectedGenre('');
                        book.setSelectedPrice('');
                        book.setSelectedAssType('');
                        navigate(STORE_ROUTE);
                    }}
                    variant="outline-success"
                    className="shadow-sm btn-sm d-flex align-items-center"
                >
                    <FaBox className="me-2" /> Store
                </Button>
            </div>


        </div>
    );
});

export default ColReader;
